import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/icons/processV2.svg'
import _imports_1 from '../../public/icons/journalsV2.svg'
import _imports_2 from '../../public/icons/explorerV2.svg'
import _imports_3 from '../../public/icons/matching/matchingV2.svg'
import _imports_4 from '../../public/icons/metadataV2.svg'
import _imports_5 from '../../public/icons/maintenanceV2.svg'
import _imports_6 from '../../public/icons/dataV2.svg'
import _imports_7 from '../../public/icons/usersV2.svg'
import _imports_8 from '../../public/icons/logV2.svg'
import _imports_9 from '../../public/icons/infoV2.svg'
import _imports_10 from '../../public/icons/double_right_arrow.svg'
import _imports_11 from '../../public/icons/double_left_arrow.svg'
import _imports_12 from '../../public/icons/explorer/context_menu/open.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ec788786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "end-user-category" }
const _hoisted_2 = { class: "sidebar-button" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "size-sm"
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "sidebar-button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "size-sm"
}, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "sidebar-button" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "size-sm"
}, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "sidebar-button" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "size-sm"
}, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "configuration-category" }
const _hoisted_15 = { class: "sidebar-button" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "size-sm"
}, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "sidebar-button" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "size-sm"
}, null, -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "sidebar-button" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "size-sm"
}, null, -1))
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "sidebar-button" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "size-sm"
}, null, -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "system-category" }
const _hoisted_28 = { class: "sidebar-button" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "size-sm"
}, null, -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "sidebar-button" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "size-sm"
}, null, -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "sidebar-button" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "size-sm"
}, null, -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "sidebar-button" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "sidebar-footer" }
const _hoisted_41 = ["title"]
const _hoisted_42 = {
  key: 0,
  src: _imports_10,
  class: "collapse-icon",
  alt: "Expand"
}
const _hoisted_43 = {
  key: 1,
  src: _imports_11,
  class: "collapse-icon",
  alt: "Collapse"
}
const _hoisted_44 = ["Key", "onClick"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme-svg",
  src: _imports_12
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "sidebar",
    class: _normalizeClass({ collapsed: _ctx.isCollapsed })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.UserCanAccessWorkflow)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: `${_ctx.getDefaultWorkflowRoute()}` },
            title: _ctx.Localizer.Localize('Sidebar_Workflow')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Workflow")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessJournals && _ctx.FeatureFlagJournals)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: `${_ctx.getDefaultJournalEntriesRoute()}` },
            title: _ctx.Localizer.Localize('Sidebar_Journals')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Journals")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: { name: _ctx.RouteNames.ExplorerRoute },
        title: _ctx.Localizer.Localize('Sidebar_Explore')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (!_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Explore")), 1))
              : _createCommentVNode("", true),
            (_ctx.Tabs.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "counter",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setShowWindowsContextMenu($event)), ["prevent","stop"]))
                }, _toDisplayString(_ctx.Tabs.length), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["to", "title"]),
      (_ctx.FeatureFlagMatching && _ctx.UserCanAccessMatching)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: { name: `${_ctx.RouteNames.MatchingUI}` },
            title: _ctx.Localizer.Localize('Sidebar_Matching')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Matching")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.UserCanAccessModels)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: String(_ctx.modelsRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Models')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Models")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessMaintenance)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: `${_ctx.getDefaultMaintenanceRoute()}` },
            title: _ctx.Localizer.Localize('Sidebar_Maintenance')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Maintenance")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessConfiure)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: { name: String(_ctx.configureRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Configuration')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Configuration")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessSecurity)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: { name: String(_ctx.securityRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Security')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Security")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_27, [
      (_ctx.UserCanAccessAudit && _ctx.FeatureFlagAuditModule)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: `${_ctx.RouteNames.AuditRoute}` },
            title: _ctx.Localizer.Localize('Sidebar_Audit')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Audit")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessLogs)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: String(_ctx.logsRoute) },
            title: _ctx.Localizer.Localize('Sidebar_Logs')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.Localizer.Localize("Sidebar_Logs")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true),
      (_ctx.UserCanAccessAbout != null)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: { name: String(_ctx.aboutRoute) },
            title: _ctx.Localizer.Localize('Sidebar_About')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.Localizer.Localize("Sidebar_About")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to", "title"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HomeExtensions, (item, i) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        to: { name: _ctx.RouteNames.HomeExtensionRoute, params: { id: item.id } },
        title: item.caption
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("img", {
              src: item.svg,
              class: "size-sm"
            }, null, 8, _hoisted_38),
            (!_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.caption), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, 1032, ["to", "title"]))
    }), 256)),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", {
        class: "collapse-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args))),
        title: _ctx.isCollapsed ? 'Expand' : 'Collapse'
      }, [
        (_ctx.isCollapsed)
          ? (_openBlock(), _createElementBlock("img", _hoisted_42))
          : (_openBlock(), _createElementBlock("img", _hoisted_43))
      ], 8, _hoisted_41)
    ]),
    (_ctx.ShowWindowsContextMenu)
      ? (_openBlock(), _createBlock(_component_ContextMenu, {
          key: 0,
          TriggerEvent: _ctx.ShowWindowsContextMenu,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ShowWindowsContextMenu = null))
        }, {
          buttons: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (tab) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "context_menu_btn",
                Key: tab.Key,
                onClick: ($event: any) => (_ctx.Open(tab))
              }, [
                _hoisted_45,
                _createTextVNode("  " + _toDisplayString(tab.Name), 1)
              ], 8, _hoisted_44))
            }), 256))
          ]),
          _: 1
        }, 8, ["TriggerEvent"]))
      : _createCommentVNode("", true)
  ], 2))
}